<script lang="ts">
	import heroPoster from "@assets/images/hero-thumb.webp?w=880&format=webp&imagetools";
	import heroVideo from "@assets/videos/hero-compressed.mp4";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import Media from "@components/common/Media.svelte";
	import { hugeHeadingParallax } from "@utils/hugeHeadingParallax.js";
	import type { ClassValue } from "svelte/elements";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { getCaseStudiesAnchor } from "@core/schema/paths/getCaseStudiesAnchor.js";
	import { getServiceAnchor } from "@core/schema/paths/getServiceAnchor.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { class: customClass }: { class?: ClassValue } = $props();
	const { tenant } = getGlobalTemplateProps();
</script>

<section
	class={[customClass, "flex full-width flex-col justify-center items-center pb-8 md:pb-16 lg:pb-20 px-2 md:px-8"]}
>
	<h1 class="huge-heading text-center text-cmcsecondary slow-down" use:hugeHeadingParallax>
		Nakopneme
		<span class="stroke-text-cmcsecondary text-cmcbg">vaši&nbsp;logistiku</span>
	</h1>
	<div
		class="w-full max-w-[28.75rem] lg:flex-row md:max-w-[79rem] bg-white/50 backdrop-blur-[4px] md:backdrop-blur-[8px] rounded-xl md:rounded-3xl p-2 md:p-4 flex flex-col gap-2 md:gap-4"
	>
		<Media
			width={816}
			height={459}
			source={{ type: "video/mp4", src: heroVideo }}
			poster={heroPoster}
			alt=""
			muted
			eager
			autoplay
			noControls
			loop
			playsInline
			class="rounded-lg md:rounded-xl w-full md:w-auto aspect-[16/9] object-cover"
			wrapperClass="inset-0 rounded-lg xl:w-[51rem] lg:w-[60%] md:w-[45%] w-full h-[12.125rem] md:h-[28.75rem] md:rounded-xl overflow-hidden"
			sourcesets={{}}
		/>
		<div class="flex flex-col justify-between gap-4 p-3 md:p-6 lg:w-[25rem]">
			<div class="font-semibold text-2xs/[1.4] md:text-base">
				<Formatted
					text="Pomáháme firmám, když jim teče do bot s logistikou: od organizace skladu, přes interim management až po vzdělávání a nábor specialistů. nl[[]]nl[[]] Na vzletná slova nás neužije. Co navrhneme, to převedeme do praxe a následně přebíráme odpovědnost za výsledky."
				/>
			</div>

			<div class="flex flex-col gap-2 w-full">
				<Link
					href="#{getServiceAnchor(tenant)}"
					variant={ButtonVariant.Primary}
					icon="arrow"
					class="w-full flex justify-between"
				>
					<Formatted text="Přejít na služby a řešení" />
				</Link>
				<Link
					href="#{getCaseStudiesAnchor(tenant)}"
					variant={ButtonVariant.Outlined}
					icon="arrow"
					class="w-full flex justify-between"
				>
					<Formatted text="Zobrazit případové studie" />
				</Link>
			</div>
		</div>
	</div>
</section>
